<template>
    <p
        class="ob1-inline-promise"
        :class="{
            'ob1-inline-promise-info': !isWarning,
            'ob1-inline-promise-warning': isWarning,
            'ob1-inline-promise-inverse': isBlack,
        }"
    >
        <span v-if="visuals.length" class="ob1-inline-promise-visual">
            <img
                v-for="(visual, index) in visuals"
                :key="visual.id || index"
                loading="lazy"
                :src="visual.url"
                :alt="visual.alt"
                class="ob1-inline-promise-img"
                aria-hidden="true"
            >
        </span>
        <span v-if="contentRows.length" class="ob1-inline-promise-content">
            <span v-for="(row, index) in contentRows" :key="`row-${index}`">
                <span
                    v-if="row.title"
                    v-msh-html="row.title"
                    class="ob1-inline-promise-title"
                    :class="{'ob1-inline-promise-small': compactText}"
                />
                <br v-if="row.title && row.text">
                <span
                    v-if="row.text"
                    v-msh-html="row.text"
                    class="ob1-inline-promise-standard"
                    :class="{'ob1-inline-promise-small': compactText}"
                />
            </span>
        </span>
    </p>
</template>

<script lang="ts">
import {defineComponent, type PropType} from "vue";
import {
    InlinePromiseAttribute,
    InlinePromiseClaim,
    InlinePromiseContentRow,
    InlinePromiseVisual
} from "./models/InlinePromise";

export default defineComponent({
    name: "InlinePromise",
    props: {
        claim: {
            type: Object as PropType<InlinePromiseClaim>,
            required: true,
        },
        isBlack: {
            type: Boolean,
            default: false,
        },
        isWarning: {
            type: Boolean,
            default: false,
        },
        compactText: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        visuals(): InlinePromiseVisual[] {
            if (Array.isArray(this.claim.visuals) && this.claim.visuals.length > 0) {
                return this.claim.visuals;
            }
            if (this.claim.image && this.claim.image.url) {
                return [this.claim.image];
            }
            return [];
        },
        attributes(): InlinePromiseAttribute[] {
            if (Array.isArray(this.claim.attributes)) {
                return this.claim.attributes;
            }
            if (this.claim.attributes && typeof this.claim.attributes === "object") {
                return [this.claim.attributes];
            }
            return [];
        },
        contentRows(): InlinePromiseContentRow[] {
            return this.attributes
                .map((attribute): InlinePromiseContentRow | null => {
                    if (!attribute) {
                        return null;
                    }

                    const title = attribute.titleHtml || attribute.title || "";
                    const text = attribute.textHtml || attribute.text || "";

                    return title || text ? {title, text} : null;
                })
                .filter((row): row is InlinePromiseContentRow => row !== null);
        },
    },
});
</script>

<style scoped lang="scss">
.ob1-inline-promise .ob1-inline-promise-visual img {
    width: 1.875rem;
    height: 1.875rem;
    flex: 0 0 1.875rem;
    object-fit: contain;
}

.ob1-inline-promise .ob1-inline-promise-visual:has(> img:nth-child(5)) {
    max-width: 6.25rem !important;
    flex-wrap: wrap !important;
}
</style>
